import { createSlice } from "@reduxjs/toolkit";

export const venueSlice = createSlice({
  name: "venue",
  initialState: {
    saveLoading: false,
    saveError: false,
    saveStatusCode: 0,
    saveMessage: "",
    getVenueLoading: false,
    getVenueError: false,
    getVenueData: null,
    getVenueMessage: "",
    getVenueStatusCode: 0,
  },
  reducers: {
    onGetVenue: (state) => ({
      ...state,
      getVenueLoading: true,
      getVenueError: false,
      getVenueData: null,
      getVenueMessage: "",
      getVenueStatusCode: 0,
    }),
    onGetVenueSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload;
      return {
        ...state,
        getVenueLoading: false,
        getVenueError: false,
        getVenueData: data,
        getVenueMessage: message,
        getVenueStatusCode: status_code,
      };
    },
    onGetVenueError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        getVenueLoading: false,
        getVenueError: true,
        getVenueData: data,
        getVenueMessage: message,
        getVenueStatusCode: status_code,
      };
    },
    onGetVenueReset: (state) => ({
      ...state,
      getVenueLoading: false,
      getVenueError: false,
      getVenueData: null,
      getVenueMessage: "",
      getVenueStatusCode: 0,
    }),
    onVenueSave: (state) => ({
      ...state,
      saveLoading: true,
      saveError: false,
      saveStatusCode: 0,
      saveMessage: "",
    }),
    onVenueSaveSuccess: (state, { payload }) => {
      const { status_code = 200, message = "" } = payload;
      return {
        ...state,
        saveLoading: false,
        saveError: false,
        saveStatusCode: status_code,
        saveMessage: message,
      };
    },
    onVenueSaveError: (state, { payload }) => {
      const { status_code = 400, message = "" } = payload;
      return {
        ...state,
        saveLoading: false,
        saveError: true,
        saveStatusCode: status_code,
        saveMessage: message,
      };
    },
    onVenueSaveReset: (state) => ({
      ...state,
      saveLoading: false,
      saveError: false,
      saveStatusCode: 0,
      saveMessage: "",
    }),
  },
});

export const {
  onVenueSave,
  onVenueSaveSuccess,
  onVenueSaveError,
  onVenueSaveReset,
  onGetVenue,
  onGetVenueSuccess,
  onGetVenueError,
  onGetVenueReset,
} = venueSlice.actions;

export default venueSlice.reducer;
